var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home_doctor"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('contractual-reporting')], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ecd037c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ContractualReporting/ContractualReporting.vue
// module id = 745
// module chunks = 0